<main class="font-satoshi">
    <router-outlet />
    <nav></nav>
</main>
